(function () {
    'use strict';

    angular
        .module('app.cart')
        .factory('CartService', CartService);

    CartService.$inject = ['$http', '$q'];

    function CartService($http, $q) {
        var service = {
            getCart: getCart,
            updateCart: updateCart,
            InsertWithParams: InsertWithParams,
            Insert: Insert,
            Increment: Increment,
            Decrement: Decrement,
            Delete: Delete
        };

        return service;

        function getCart() {
            var deferred = $q.defer();

            $http.get("/Cart")
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function updateCart(cart) {
            var deferred = $q.defer();

            $http.put("/Cart/" + cart.Id, cart)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function InsertWithParams(params) {
            var cartProduct = {
                ProductId: params.productID,
                Quantity: params.quantity,
                Product: {
                    Name: params.name,
                    Price: params.price,
                    DefaultIncrement: params.increment,
                    PriceWithDiscount: params.priceWithDiscount,
                    BaseGroupProductId: params.baseGroupProductId,
                    BaseGroupProduct: {
                        Name: params.baseGroupProductName,
                        ProductMedia: [
                            {
                                FileName: params.baseGroupProductImg
                            }
                        ]
                    },
                    ProductMedia: [
                        {
                            FileName: params.image
                        }
                    ]
                }
            };
            return Insert(cartProduct);
        }

        function Insert(cartProduct) {
            var deferred = $q.defer();

            cartProduct.Product = null;
            $http.post("/Cart/Product/" + cartProduct.ProductId + "/" + cartProduct.Quantity, cartProduct)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Increment(cartProduct) {
            var deferred = $q.defer();

            $http.put("/Cart/Product/" + cartProduct.ProductId + "/" + (cartProduct.Quantity + 1),
                {
                    ProductId: cartProduct.ProductId,
                    Quantity: cartProduct.Quantity + 1
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Decrement(cartProduct) {
            var deferred = $q.defer();

            $http.put("/Cart/Product/" + cartProduct.ProductId + "/" + (cartProduct.Quantity - 1),
                {
                    ProductId: cartProduct.ProductId,
                    Quantity: cartProduct.Quantity - 1
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Delete(cartProduct) {
            var deferred = $q.defer();

            $http.delete("/Cart/Product/" + cartProduct.ProductId)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();